import ExcelJS from "exceljs";

export default function Summary_report(filename, candidateData) {
  console.log("candidate data to be seen here console...", candidateData);

  const headings = [
    "REQUEST/INVOICE.NO",
    "INVOICE_TYPE",
    "QUANTITY",
    "MONTHS",
    "INVOICE AMOUNT",
    "INVOICE SENT DATE",
    "AMOUNT RECEIVED",
    "CREDIT NOTE",
    "BALANCE AMOUNT",
  ];

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  // Create title row
  const titleRow = sheet.getRow(1);
  titleRow.getCell(1).value = "sno."; // for serial numbers

  for (let i = 0; i <= headings.length; i++) {
    titleRow.getCell(i + 1).style = {
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" }, // Yellow
      },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    titleRow.getCell(i + 2).value = headings[i];
    const column = sheet.getColumn(i + 2);
    column.width = 24;
  }

  sheet.getRow(1).height = 30; // Header height

  // Populate rows with candidateData
  candidateData.forEach((candidate, index) => {
    const row = sheet.getRow(index + 2); // Start from 2nd row
    row.getCell(1).value = index + 1; // Serial number
    row.getCell(2).value = candidate.invoice_no;
    row.getCell(3).value = candidate.invoice_type;
    row.getCell(4).value = candidate.quantity;
    row.getCell(5).value = candidate.months;
    row.getCell(6).value = candidate.invoice_amount;
    row.getCell(7).value = candidate.invoice_sent_date
      ? new Date(candidate.invoice_sent_date)
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .split(" ")
          .join("-")
          .toUpperCase()
      : "-----";
    row.getCell(8).value = candidate.amount_received
      ? candidate.amount_received
      : 0;
    row.getCell(9).value = candidate.credit_note ? candidate.credit_note : 0;
    row.getCell(10).value =
      parseInt(candidate.invoice_amount ? candidate.invoice_amount : 0) -
      (parseInt(candidate.amount_received ? candidate.amount_received : 0) +
        parseInt(candidate?.credit_note === null ? 0 : candidate?.credit_note));
  });

  // Generate and download Excel file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename ? `${filename}` : "Candidate_Flight_Details.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}
